var _ = "_semiBold_qjlx4_113",
  y = "_medium_qjlx4_117",
  o = "_regular_qjlx4_121",
  p = "_inline_qjlx4_125",
  t = "_responsive_qjlx4_130",
  r = "_truncate_qjlx4_145",
  a = {
    "typography-h1": "_typography-h1_qjlx4_43",
    "typography-h2": "_typography-h2_qjlx4_44",
    "typography-h3": "_typography-h3_qjlx4_45",
    "typography-h4": "_typography-h4_qjlx4_46",
    "typography-subHeading": "_typography-subHeading_qjlx4_47",
    "typography-body1": "_typography-body1_qjlx4_48",
    "typography-body2": "_typography-body2_qjlx4_49",
    "typography-body3": "_typography-body3_qjlx4_50",
    semiBold: _,
    medium: y,
    regular: o,
    inline: p,
    responsive: t,
    truncate: r
  };
export { a as default, p as inline, y as medium, o as regular, t as responsive, _ as semiBold, r as truncate };